<template>
    <div
        :class="[$style['mds-notification-container'], classObject, positionClass, widthClass]"
        :data-mds-version="version"
        :aria-live="ariaLive"
        role="status"
    >
        <!-- transition-group default wrapper is span hence tag prop -->
        <transition-group
            :enter-active-class="$style['mds-notification-container--enter-active']"
            :leave-active-class="$style['mds-notification-container--leave-active']"
            tag="div"
        >
            <slot></slot>
        </transition-group>
    </div>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsNotificationContainer',
        props: {
            ariaLive: {
                type: String,
                default: 'polite',
                validator(value) {
                    return ['polite', 'assertive'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `polite`, `assertive`.',
                    description: 'Sets the `aria-live` attribute.',
                },
            },
            mastheadPadding: {
                type: String,
                validator(value) {
                    return ['below-masthead', 'below-masthead-tall'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `below-masthead`, `below-masthead-tall`.',
                    description:
                        'Sets the top padding on the notification container to account for different page shell masthead sizes. Should only be used when `position="top-center"`',
                },
            },
            position: {
                type: String,
                default: 'top-center',
                validator(value) {
                    return ['bottom-right', 'top-center'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `bottom-right`, `top-center`.',
                    description: 'Sets the position of the notification.',
                },
            },
            width: {
                type: String,
                default: '500px',
                validator(value) {
                    return ['350px', '500px', '650px'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `350px`, `500px`, `650px`.',
                    description: 'Sets the width of the notification.',
                },
            },
            version: {
                type: String,
                default: `${name}-${version}`,
                docs: {
                    validation: 'Read-only',
                    description:
                        'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
                },
            },
        },
        computed: {
            classObject() {
                const obj = {};
                obj[this.$style[`mds-notification-container--${this.mastheadPadding}`]] = this.mastheadPadding;

                return obj;
            },
            positionClass() {
                return this.$style[`mds-notification-container--${this.position}`];
            },
            widthClass() {
                return this.$style[`mds-notification-container--width-${this.width}`];
            },
        },
    };
</script>

<style lang="scss" module>
    @import './notification-container.scss';
</style>
